<template>
	<div class="page-wrapper">
		<div class="page page-settings">
			<div class="container">
				<div class="page-header">
					<h1 class="page-title">
						<router-link class="text" to="/settings">{{ $t('Settings') }}</router-link>
						<i class="separator material-icons">chevron_right</i>
						<span class="page-breadcrumb">{{ title }}</span>
					</h1>
				</div>
				<div class="page-content">
					<div class="box p-0" v-if="!user">
						<div class="is-loading p-3 text-center"></div>
					</div>
					<div class="" v-else>
						<!-- Shipping Management -->
						<div class="integration-item box p-0">
							<div class="integration-app">
								<div class="wrapper">
									<div class="integration-app-logo">
										<div class="text">{{ $t('Shipping Management') }}</div>
									</div>
								</div>
							</div>
							<div class="integration-accounts">
								<div class="integration-account">
									<div class="wrapper" v-if="!loading">
										<div class="container-fluid p-0">
											<div class="row">
												<div class="col-12">
													<h4>{{ $t('Auto Change Order Status') }}</h4>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label><b>{{ $t('On Request Pickup') }}</b></label>
														<select
															class="form-control"
															v-model="requestPickStatus">
															<option
																v-for="(item, index) in statusChangeOptions"
																:key="index"
																:value="item.value">
																{{ item.label }}
															</option>
														</select>
														<div class="pc-input-desc">
															{{ $t('settings.shipping.requestPickupDesc') }}
														</div>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label><b>{{ $t('When Package Delivered') }}</b></label>
														<select
															class="form-control"
															v-model="deliveredStatus">
															<option
																v-for="(item, index) in statusDeliveredOptions"
																:key="index"
																:value="item.value">
																{{ item.label }}
															</option>
														</select>
														<div class="pc-input-desc">
															{{ $t('settings.shipping.deliveredStatusDesc') }}
														</div>
													</div>
												</div>
											</div>
											<div class="form-group text-right">
												<button
													type="button"
													class="btn btn-primary d-flex align-items-center ml-a"
													:class="[{ 'is-loading': isSavingSettings }]"
													@click="setUserSetting">
													<i class="material-icons">save</i>
													<span>{{ $t('Save') }}</span>
												</button>
											</div>
										</div>
									</div>
									<div
										class="is-loading large dark mt-3 mb-4"
										v-if="loading">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modals"></div>

		<notifications group="user_settings" position="bottom right" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import userApi from '@/api/user';
import { duplicateVar } from '@/lib/helper';
import { statusChangeOptions, statusDeliveredOptions } from '@/lib/statics';

export default {
	name: 'SettingsShipping',
	data() {
		return {
			loading: false,
			title: 'Shipping',
			requestPickStatus: 'initial',
			deliveredStatus: 'initial',
			isSaveSetiing: false,
			userSettings: null,
			instantPayment: {
				status: 'processing',
				logistic_enabled: true,
			},
			isSavingInstant: false,
			statusChangeOptions: duplicateVar(statusChangeOptions),
			statusDeliveredOptions: duplicateVar(statusDeliveredOptions),
			isSavingSettings: false,
		};
	},
	methods: {
		init() {
			this.getUserSettings();
		},

		getParams() {
			const shipping = [
				{
					key: 'request_pickup_status',
					value: this.requestPickStatus,
				},
				{
					key: 'delivered_status',
					value: this.deliveredStatus,
				},
			];

			return JSON.stringify(shipping);
		},

		getUserSettings() {
			this.loading = true;
			const params = {
				key: 'request_pickup_status,delivered_status',
			};
			const callback = (response) => {
				const settings = response.data;
				settings.forEach((setting) => {
					if (setting.value && setting.value !== '') {
						if (setting.key === 'request_pickup_status') {
							this.requestPickStatus = setting.value;
						} else if (setting.key === 'delivered_status') {
							this.deliveredStatus = setting.value;
						}
					}
				});

				this.loading = false;
			};
			const errorCallback = () => {
				this.loading = false;
				this.$notify({
					group: 'user_settings',
					title: 'Setting',
					text: 'User Setting not updated, please try again',
					type: 'error',
				});
			};
			userApi.getUserSetting(params, callback, errorCallback);
		},

		setUserSetting() {
			this.isSavingSettings = true;
			const params = duplicateVar(this.getParams());
			const callback = (response) => {
				console.log(response);
				this.isSavingSettings = false;
				this.$notify({
					group: 'user_settings',
					title: 'Setting',
					text: 'Setting updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isSavingSettings = false;
				this.$notify({
					group: 'user_settings',
					title: 'Setting',
					text: 'Setting not updated, please try again',
					type: 'error',
				});
			};
			userApi.setUserSetting(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isTester: 'isTester',
			isHasFeature: 'isHasFeature',
		}),
	},
	created() {
		if (this.user) {
			this.init();
		}
	},
	watch: {
		user() {
			this.init();
		},
		settings() {
			this.getUserSettings();
		},
	},
};
</script>
